// Recovered compiled webpack factory 3463. Edit this function expression; run npm run build.
(e, t) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "reportGlobalError", {
      enumerable: !0,
      get: function () {
        return r;
      },
    }));
  let r =
    "function" == typeof reportError
      ? reportError
      : (e) => {
          globalThis.console.error(e);
        };
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
